
import { motion } from "framer-motion";

export const HebrewFinancialSystem = () => {
  return (
    <div className="bg-blue-50 p-6 rounded-lg mb-8">
      <h2 className="text-xl font-semibold mb-4 text-blue-800">איך עובדות הלוואות בפינלנד</h2>
      <p className="mb-4">
        לפינלנד יש מערכת בנקאית יציבה ובטוחה עם שיעורי ריבית תחרותיים. כל בקשות ההלוואה דורשות תעודת זהות פינית (henkilötunnus) ובדרך כלל בודקות את מידע האשראי שלך באמצעות מרשם Suomen Asiakastieto.
      </p>
      <p className="mb-4">
        רוב ההלוואות בפינלנד דורשות:
      </p>
      <ul className="list-disc pr-5 mb-4 space-y-2">
        <li>הכנסה קבועה והיסטוריית אשראי טובה</li>
        <li>אזרחות פינית או תושבות קבע</li>
        <li>גיל של לפחות 18 שנים (חלק מההלוואות דורשות 20+ שנים)</li>
        <li>ללא פיגורים בתשלום או חסימות אשראי</li>
      </ul>
      <p>
        עם Lainasampo.fi, תוכל להשלים בקשה אחת ולקבל הצעות הלוואה מרובות ממוסדות פיננסיים ובנקים פיניים שונים, ובכך לחסוך זמן ואולי להבטיח שיעורי ריבית טובים יותר.
      </p>
    </div>
  );
};
